module.exports = __webpack_public_path__ + "img/edge.88230394.svg";